<template>
  <b-row class="fixed-row-bottom">
    <b-col md="12">
      <div class="absolute bottom-0">
        <b-row>
          <b-col class="col-12 col-md-7">
            <div
              v-if="!onlyLogo"
              class="mb-3 d-flex justify-content-center justify-content-md-start text-gray pt-2"
            >
              <p
                class="mr-4"
                @click="
                  $router.push({
                    name: 'privacy-policy',
                    params: { shouldAccept: false }
                  })
                "
              >
                Privacy Policy
              </p>
              <p
                class="mr-4"
                @click="
                  $router.push({
                    name: 'terms-of-use',
                    params: { shouldAccept: false }
                  })
                "
              >
                Terms of Use
              </p>
            </div>
          </b-col>
          <b-col md="5">
            <a href="https://www.tailie.nl" target="_blank">
              <p class="text-center text-md-right mr-md-4 font-italic">
                <TailieLogo style="max-width: 150px" />
              </p>
            </a>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import TailieLogo from "./../../assets/images/LOGO_Tailie_Blauw_powered_by.svg";

export default {
  name: "bottom-policies",
  components: {
    TailieLogo
  },
  computed: {
    showLogout() {
      return this.logoutButton;
    }
  },
  props: {
    onlyLogo: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style scoped>
p {
  font-size: smaller;
}

p:hover {
  text-decoration: underline;
  cursor: pointer;
}

/* .fixed-row-bottom { position: absolute; bottom: 0; width: 100%} */
</style>
